import React, { Component } from "react";
import PropTypes       from "prop-types";
import { connect }     from "react-redux";
//MY COMPONENTS
import Loader          from "../Components/component_Loader";
import ErrorMessage    from "../Components/component_MsgError";
//MATERIAL COMPONENTS
import FlatButton      from "material-ui/FlatButton";
import RaisedButton    from "material-ui/RaisedButton";
import TextField       from "material-ui/TextField";
import Paper           from "material-ui/Paper";
//ACTION
import { confirmEmail, goToLogin } from "../Actions/Action_ServiceRequest_ConfermaEmail";
import { LABEL_CanNotConfirmEmail, LABEL_EmailConfirmed, LABEL_GoToLogin } from "../Utils/Strings/Labels";
import { getUserInfo } from "../Actions/Action_Authentication";
//UTILS
import * as ROLES      from "../Utils/Roles_Types.js";
import { checkUserLanguage } from "../Utils/Check_Value.js";
//STYLES
import "../CSS/style_Conferma-Email.css";

const USERINFO = JSON.parse(localStorage.getItem(ROLES.USERINFO_KEY));
const USERLANGUAGE  = checkUserLanguage(USERINFO);

class ConfermaEmail extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      label : {
        title : "Conferma Email",
        body  : "Clicca qui per confermare il tuo account BilApp",
        button : "CONFERMA"
      },
      paper : {
        title : {
          fontSize: "25px",
          textAlign: "center",
          color: "#6b9add"
        },
        titleError : {
          fontSize: "27px",
          textAlign: "center",
          color: "red"
        },
        body : {
          fontSize: "20px",
          paddingTop: "50px",
          paddingLeft: "20px"
        },
        button : {
          width: "80%",
          marginStart: 10
        }
      },
      token : this.props.location.search.replace("?token=", "")
    }

  }

  handleConfirmButtonClick = () => {
    this.props.dispatch(confirmEmail(this.state.token));
  }

  handleLoginButtonClick = () => {
    this.props.dispatch(goToLogin());
  }
  //Richiamata alla
  componentDidMount() {
    //this.props.dispatch();
  }

  render() {

    return <div>
        <Loader isFetching={this.props.isFetching} />
        <ErrorMessage message={this.props.errorMessage} />
        <div className={"confirm-container "+this.props.animation}>
          <Paper className="paper" zDepth={3}>
            <section style={this.props.errorMessage ? this.state.paper.titleError : this.state.paper.title}>
              { ! this.props.confirmed && 
                ( this.props.errorMessage && LABEL_CanNotConfirmEmail[USERLANGUAGE] )
                  || this.state.label.title }
              { this.props.confirmed && LABEL_EmailConfirmed[USERLANGUAGE]}
            </section>
            <section style={this.state.paper.body}>
              { !this.props.confirmed && ( this.props.errorMessage  || this.state.label.body ) }
              { this.props.confirmed && LABEL_GoToLogin[USERLANGUAGE] }
            </section>
            <section style={this.state.paper.body}>
              <center>
                { !this.props.confirmed &&
                  <RaisedButton 
                    label={this.state.label.button}
                    primary={true}
                    style={this.state.paper.button}
                    disabled={this.props.errorMessage !== null}
                    onClick={this.handleConfirmButtonClick}/>
                }
                { this.props.confirmed &&
                  <RaisedButton 
                    label={LABEL_GoToLogin[USERLANGUAGE]}
                    primary={true}
                    style={this.state.paper.button}
                    onClick={this.handleLoginButtonClick}/>
                }
              </center>
            </section>
          </Paper>
        </div>
      </div>;
  }
}

ConfermaEmail.propTypes = {
  dispatch: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  const { confermaEmailReducer } = state;
  const { isFetching, errorMessage, animation, confirmed } = confermaEmailReducer;
  return {
    isFetching,
    errorMessage,
    animation,
    confirmed
  };
}

export default connect(mapStateToProps)(ConfermaEmail);



// WEBPACK FOOTER //
// ./src/Containers/ConfermaEmail.js